import { render, staticRenderFns } from "./Kinds.vue?vue&type=template&id=6c8f0386&scoped=true&"
import script from "./Kinds.vue?vue&type=script&lang=js&"
export * from "./Kinds.vue?vue&type=script&lang=js&"
import style0 from "./Kinds.vue?vue&type=style&index=0&id=6c8f0386&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f0386",
  null
  
)

export default component.exports